import { map } from 'rxjs/operators/map';
import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { NbTokenService, NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { Ferme } from '../models/ferme.model';
import { CurrentUserService } from './currentUserService';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': '',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class FermeService {
  baseUrl: string = environment.apiUrl;
  public selectedFerme: Ferme;
  public grantedFermes: any;
  constructor(private injector: Injector, private httpClient: HttpClient) {}

  protected get authService(): NbAuthService {
    return this.injector.get(NbAuthService);
  }

  public getFermes(){
    return this.httpClient.get(this.baseUrl + '/fermes');
  }

  public getGrantedFermes(idUser: number){
    return this.httpClient.get(this.baseUrl + '/ferme/' + idUser);
  }

  public selectFerme(ferme: Ferme){
    this.selectedFerme = ferme;
    localStorage.setItem('selectedFerme', JSON.stringify(this.selectedFerme));
  }
}
